module.exports = ".avatar {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%; }\n  .avatar.normal {\n    width: 60px;\n    height: 60px; }\n  .avatar.small {\n    width: 40px;\n    height: 40px; }\n  div {\n  display: inline-block; }\n  .border {\n  border-radius: 60px;\n  padding: 5px; }\n  .background {\n  background-color: white; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/show-avatar/show-avatar.component.scss
// module id = ./src/app/shared/components/show-avatar/show-avatar.component.scss
// module chunks = main